/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 1.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { StatutoryDepositRequest } from '../models';
import { StatutoryDepositSummaryViewIEnumerableResponse } from '../models';
import { StatutoryDepositTransactionViewIEnumerableResponse } from '../models';
/**
 * StatutoryDepositApi - axios parameter creator
 * @export
 */
export const StatutoryDepositApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StatutoryDepositGetSummaryBankInformationPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV1StatutoryDepositGetSummaryBankInformationPracticeIdGet.');
            }
            const localVarPath = `/api/v1/StatutoryDeposit/GetSummaryBankInformation/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StatutoryDepositRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StatutoryDepositGetTransactionsPost: async (body?: StatutoryDepositRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StatutoryDeposit/GetTransactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatutoryDepositApi - functional programming interface
 * @export
 */
export const StatutoryDepositApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StatutoryDepositGetSummaryBankInformationPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatutoryDepositSummaryViewIEnumerableResponse>> {
            const localVarAxiosArgs = await StatutoryDepositApiAxiosParamCreator(configuration).apiV1StatutoryDepositGetSummaryBankInformationPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {StatutoryDepositRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StatutoryDepositGetTransactionsPost(body?: StatutoryDepositRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatutoryDepositTransactionViewIEnumerableResponse>> {
            const localVarAxiosArgs = await StatutoryDepositApiAxiosParamCreator(configuration).apiV1StatutoryDepositGetTransactionsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * StatutoryDepositApi - factory interface
 * @export
 */
export const StatutoryDepositApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StatutoryDepositGetSummaryBankInformationPracticeIdGet(practiceId: number, options?: any): AxiosPromise<StatutoryDepositSummaryViewIEnumerableResponse> {
            return StatutoryDepositApiFp(configuration).apiV1StatutoryDepositGetSummaryBankInformationPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatutoryDepositRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StatutoryDepositGetTransactionsPost(body?: StatutoryDepositRequest, options?: any): AxiosPromise<StatutoryDepositTransactionViewIEnumerableResponse> {
            return StatutoryDepositApiFp(configuration).apiV1StatutoryDepositGetTransactionsPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatutoryDepositApi - object-oriented interface
 * @export
 * @class StatutoryDepositApi
 * @extends {BaseAPI}
 */
export class StatutoryDepositApi extends BaseAPI {
    /**
     * 
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatutoryDepositApi
     */
    public apiV1StatutoryDepositGetSummaryBankInformationPracticeIdGet(practiceId: number, options?: any) {
        return StatutoryDepositApiFp(this.configuration).apiV1StatutoryDepositGetSummaryBankInformationPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {StatutoryDepositRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatutoryDepositApi
     */
    public apiV1StatutoryDepositGetTransactionsPost(body?: StatutoryDepositRequest, options?: any) {
        return StatutoryDepositApiFp(this.configuration).apiV1StatutoryDepositGetTransactionsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
